import React, { useState, useEffect } from "react";
import PDFFile from "../PDFFile";

import { PDFDownloadLink } from "@react-pdf/renderer";
import PdfPreview from "../PdfPreview";

function Form() {
  const [showAdditional, setShowAdditional] = useState(false);
  const [inputValue, setInputValue] = useState({
    firstName: "",
    lastName: "",
    jobTitle: "",
    email: "",
    phone: "",
    photo: "",
    country: "",
    city: "",
    address: "",
    postalCode: "",
    drivingLicense: "",
    nationality: "",
    dateOfBirth: "",
    professionalSummery: "",
    employmentHistory: [
      {
        prevDesignation: "",
        prevCompany: "",
        startDate: "",
        endDate: "",
        jobLocations: "",
        JobDescription: "",
      },
    ],
    educations: [
      {
        instituteName: "",
        degree: "",
        passingYear: "",
        degreeLocation: "",
      },
    ],
    skills: "",
    interest: "",
    links: [
      {
        title: "",
        value: "",
      },
    ],
  });
  const [records, setRecords] = useState([]);

  const [previewUrl, setPreviewUrl] = useState(null);

  const arrowUp = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      class="bi bi-chevron-up"
      viewBox="0 0 16 16"
    >
      <path
        fill-rule="evenodd"
        d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z"
      />
    </svg>
  );

  const arrowDown = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-chevron-down"
      viewBox="0 0 16 16"
    >
      <path
        fillRule="evenodd"
        d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
      />
    </svg>
  );

  const plusIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-plus-circle-dotted"
      viewBox="0 0 16 16"
    >
      <path d="M8 0c-.176 0-.35.006-.523.017l.064.998a7.117 7.117 0 0 1 .918 0l.064-.998A8.113 8.113 0 0 0 8 0zM6.44.152c-.346.069-.684.16-1.012.27l.321.948c.287-.098.582-.177.884-.237L6.44.153zm4.132.271a7.946 7.946 0 0 0-1.011-.27l-.194.98c.302.06.597.14.884.237l.321-.947zm1.873.925a8 8 0 0 0-.906-.524l-.443.896c.275.136.54.29.793.459l.556-.831zM4.46.824c-.314.155-.616.33-.905.524l.556.83a7.07 7.07 0 0 1 .793-.458L4.46.824zM2.725 1.985c-.262.23-.51.478-.74.74l.752.66c.202-.23.418-.446.648-.648l-.66-.752zm11.29.74a8.058 8.058 0 0 0-.74-.74l-.66.752c.23.202.447.418.648.648l.752-.66zm1.161 1.735a7.98 7.98 0 0 0-.524-.905l-.83.556c.169.253.322.518.458.793l.896-.443zM1.348 3.555c-.194.289-.37.591-.524.906l.896.443c.136-.275.29-.54.459-.793l-.831-.556zM.423 5.428a7.945 7.945 0 0 0-.27 1.011l.98.194c.06-.302.14-.597.237-.884l-.947-.321zM15.848 6.44a7.943 7.943 0 0 0-.27-1.012l-.948.321c.098.287.177.582.237.884l.98-.194zM.017 7.477a8.113 8.113 0 0 0 0 1.046l.998-.064a7.117 7.117 0 0 1 0-.918l-.998-.064zM16 8a8.1 8.1 0 0 0-.017-.523l-.998.064a7.11 7.11 0 0 1 0 .918l.998.064A8.1 8.1 0 0 0 16 8zM.152 9.56c.069.346.16.684.27 1.012l.948-.321a6.944 6.944 0 0 1-.237-.884l-.98.194zm15.425 1.012c.112-.328.202-.666.27-1.011l-.98-.194c-.06.302-.14.597-.237.884l.947.321zM.824 11.54a8 8 0 0 0 .524.905l.83-.556a6.999 6.999 0 0 1-.458-.793l-.896.443zm13.828.905c.194-.289.37-.591.524-.906l-.896-.443c-.136.275-.29.54-.459.793l.831.556zm-12.667.83c.23.262.478.51.74.74l.66-.752a7.047 7.047 0 0 1-.648-.648l-.752.66zm11.29.74c.262-.23.51-.478.74-.74l-.752-.66c-.201.23-.418.447-.648.648l.66.752zm-1.735 1.161c.314-.155.616-.33.905-.524l-.556-.83a7.07 7.07 0 0 1-.793.458l.443.896zm-7.985-.524c.289.194.591.37.906.524l.443-.896a6.998 6.998 0 0 1-.793-.459l-.556.831zm1.873.925c.328.112.666.202 1.011.27l.194-.98a6.953 6.953 0 0 1-.884-.237l-.321.947zm4.132.271a7.944 7.944 0 0 0 1.012-.27l-.321-.948a6.954 6.954 0 0 1-.884.237l.194.98zm-2.083.135a8.1 8.1 0 0 0 1.046 0l-.064-.998a7.11 7.11 0 0 1-.918 0l-.064.998zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z" />
    </svg>
  );

  const trashIcon = (
    <svg
      width="20px"
      height="20px"
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#fff"
        d="M195.2 195.2a64 64 0 0 1 90.496 0L512 421.504 738.304 195.2a64 64 0 0 1 90.496 90.496L602.496 512 828.8 738.304a64 64 0 0 1-90.496 90.496L512 602.496 285.696 828.8a64 64 0 0 1-90.496-90.496L421.504 512 195.2 285.696a64 64 0 0 1 0-90.496z"
      />
    </svg>
  );

  const avater = (
    <svg
      className="h-[68px] w-[68px] text-gray-300"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path
        fillRule="evenodd"
        d="M18.685 19.097A9.723 9.723 0 0021.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 003.065 7.097A9.716 9.716 0 0012 21.75a9.716 9.716 0 006.685-2.653zm-12.54-1.285A7.486 7.486 0 0112 15a7.486 7.486 0 015.855 2.812A8.224 8.224 0 0112 20.25a8.224 8.224 0 01-5.855-2.438zM15.75 9a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z"
        clipRule="evenodd"
      />
    </svg>
  );

  const handleInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputValue({ ...inputValue, [name]: value });
  };

  const addNewLinks = (e) => {
    e.preventDefault();
    setInputValue((prevState) => ({
      ...prevState,
      links: [...prevState.links, { title: "", value: "" }],
    }));
  };

  const addEmploymentHistory = (e) => {
    e.preventDefault();
    setInputValue((prevState) => ({
      ...prevState,
      employmentHistory: [
        ...prevState.employmentHistory,
        {
          prevDesignation: "",
          prevCompany: "",
          startDate: "",
          endDate: "",
          jobLocations: "",
          JobDescription: "",
        },
      ],
    }));
  };

  const addEducation = (e) => {
    e.preventDefault();
    setInputValue((prevState) => ({
      ...prevState,
      educations: [
        ...prevState.educations,
        {
          instituteName: "",
          degree: "",
          passingYear: "",
          degreeLocation: "",
        },
      ],
    }));
  };

  const handleFileInputChange = (e) => {
    const selectedFile = e.target.files[0];

    if (selectedFile) {
      const reader = new FileReader();
      reader.onload = () => {
        setPreviewUrl(reader.result);
      };
      reader.readAsDataURL(selectedFile);
    } else {
      setPreviewUrl(null);
    }
  };

  const handleAvaterDeleteClick = () => {
    setPreviewUrl(null);
  };

  useEffect(() => {
    const newRecord = { ...inputValue, id: new Date().getTime().toString() };
    setRecords([newRecord]);
  }, [inputValue]);

  return (
    <>
      <div className="flex">
        <div className="basis-1/2 p-14 overflow-auto h-screen">
          <div className="text-center">
            <h1 className="text-3xl mb-8">Resume</h1>
          </div>
          <form>
            <h3 className="text-lg mb-4">Personal Details</h3>
            <div className="flex gap-4 mb-4">
              <div className="basis-1/2">
                <div className="block">
                  <label className="label">Job Title</label>
                  <input
                    type="text"
                    name="jobTitle"
                    value={inputValue.jobTitle}
                    onChange={handleInput}
                    className="form__control"
                  />
                </div>
              </div>
              <div className="basis-1/2">
                <div className="col-span-full">
                  <div className="flex items-center gap-x-3">
                    {previewUrl ? (
                      <img
                        className="h-[68px] w-[68px] rounded-full"
                        src={previewUrl}
                        alt="Preview"
                      />
                    ) : (
                      avater
                    )}
                    <label>
                      <input
                        type="file"
                        className="hidden"
                        onChange={handleFileInputChange}
                      />
                      <span
                        type="button"
                        className="rounded-md bg-white py-1.5 px-2.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 cursor-pointer"
                      >
                        {previewUrl ? "Change" : "Upload"}
                      </span>
                    </label>
                    {previewUrl ? (
                      <span
                        className="rounded-md bg-red-500 py-1.5 px-1.5 text-sm font-semibold text-gray-900 shadow-sm cursor-pointer"
                        onClick={handleAvaterDeleteClick}
                      >
                        {trashIcon}
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="flex gap-4 mb-4">
              <div className="basis-1/2">
                <div className="block">
                  <label className="label">First Name</label>
                  <input
                    type="text"
                    name="firstName"
                    value={inputValue.firstName}
                    onChange={handleInput}
                    className="form__control"
                  />
                </div>
              </div>
              <div className="basis-1/2">
                <div className="block">
                  <label className="label">Last Name</label>
                  <input
                    type="text"
                    name="lastName"
                    value={inputValue.lastName}
                    onChange={handleInput}
                    className="form__control"
                  />
                </div>
              </div>
            </div>
            <div className="flex gap-4 mb-4">
              <div className="basis-1/2">
                <div className="block">
                  <label className="label">Email</label>
                  <input
                    type="email"
                    name="email"
                    value={inputValue.email}
                    onChange={handleInput}
                    className="form__control"
                  />
                </div>
              </div>
              <div className="basis-1/2">
                <div className="block">
                  <label className="label">Phone</label>
                  <input
                    type="phone"
                    name="phone"
                    value={inputValue.phone}
                    onChange={handleInput}
                    className="form__control"
                  />
                </div>
              </div>
            </div>
            <div className="flex gap-4 mb-4">
              <div className="basis-1/2">
                <div className="block">
                  <label className="label">Country</label>
                  <input
                    type="text"
                    name="country"
                    value={inputValue.country}
                    onChange={handleInput}
                    className="form__control"
                  />
                </div>
              </div>
              <div className="basis-1/2">
                <div className="block">
                  <label className="label">City</label>
                  <input
                    type="text"
                    name="city"
                    value={inputValue.city}
                    onChange={handleInput}
                    className="form__control"
                  />
                </div>
              </div>
            </div>

            {showAdditional && (
              <>
                <div className="flex gap-4 mb-4">
                  <div className="basis-4/5">
                    <div className="block">
                      <label className="label">Address</label>
                      <input
                        type="text"
                        name="address"
                        value={inputValue.address}
                        onChange={handleInput}
                        className="form__control"
                      />
                    </div>
                  </div>
                  <div className="basis-1/5">
                    <div className="block">
                      <label className="label">Postal Code</label>
                      <input
                        type="number"
                        name="postalCode"
                        value={inputValue.postalCode}
                        onChange={handleInput}
                        className="form__control"
                      />
                    </div>
                  </div>
                </div>
                <div className="flex gap-4 mb-4">
                  <div className="basis-1/3">
                    <div className="block">
                      <label className="label">Date of Birth</label>
                      <input
                        type="text"
                        name="dateOfBirth"
                        value={inputValue.dateOfBirth}
                        onChange={handleInput}
                        className="form__control"
                      />
                    </div>
                  </div>
                  <div className="basis-1/3">
                    <div className="block">
                      <label className="label">Driving License</label>
                      <input
                        type="text"
                        name="drivingLicense"
                        value={inputValue.drivingLicense}
                        onChange={handleInput}
                        className="form__control"
                      />
                    </div>
                  </div>
                  <div className="basis-1/3">
                    <div className="block">
                      <label className="label">Nationality</label>
                      <input
                        type="text"
                        name="nationality"
                        value={inputValue.nationality}
                        onChange={handleInput}
                        className="form__control"
                      />
                    </div>
                  </div>
                </div>
              </>
            )}

            <span
              className="text-base cursor-pointer mt-1 mb-2 inline-flex items-center gap-1 text-indigo-500"
              onClick={() => setShowAdditional(!showAdditional)}
            >
              {showAdditional ? "Hide" : "Show"} Additional Details{" "}
              {showAdditional ? arrowUp : arrowDown}
            </span>

            <div className="mb-4 mt-8">
              <div className="block">
                <h3 className="text-lg mb-4">Professional Summary</h3>
                <label className="label">
                  Write 2-4 short & energetic sentences to interest the reader!
                  Mention your role, experience & most importantly - your
                  biggest achievements, best qualities and skills.
                </label>
                <textarea
                  name="professionalSummery"
                  className="form__control resize-none h-28 pt-4"
                  onChange={handleInput}
                  value={inputValue.professionalSummery}
                />
              </div>
            </div>

            <div className="mb-4 mt-8">
              <div className="block">
                <h3 className="text-lg mb-4">Employment History</h3>
                <label className="label mb-0">
                  Show your relevant experience (last 10 years). Use bullet
                  points to note your achievements, if possible - use
                  numbers/facts (Achieved X, measured by Y, by doing Z).
                </label>

                <div className="space-y-4 divide-y">
                  {inputValue.employmentHistory.map((employment, index) => (
                    <div className="pt-4" key={index}>
                      <div className="flex gap-4 mb-4">
                        <div className="basis-1/2">
                          <div className="block">
                            <label className="label">Designation</label>
                            <input
                              type="text"
                              className="form__control"
                              onChange={(e) => {
                                const newHistory = [
                                  ...inputValue.employmentHistory,
                                ];
                                newHistory[index] = {
                                  ...newHistory[index],
                                  prevDesignation: e.target.value,
                                };
                                setInputValue({
                                  ...inputValue,
                                  employmentHistory: newHistory,
                                });
                              }}
                              value={employment.prevDesignation}
                            />
                          </div>
                        </div>
                        <div className="basis-1/2">
                          <div className="block">
                            <label className="label">Company</label>
                            <input
                              type="text"
                              className="form__control"
                              onChange={(e) => {
                                const newHistory = [
                                  ...inputValue.employmentHistory,
                                ];
                                newHistory[index] = {
                                  ...newHistory[index],
                                  prevCompany: e.target.value,
                                };
                                setInputValue({
                                  ...inputValue,
                                  employmentHistory: newHistory,
                                });
                              }}
                              value={employment.prevCompany}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="flex gap-4 mb-4">
                        <div className="basis-1/3">
                          <div className="block">
                            <label className="label">Start Date</label>
                            <input
                              type="text"
                              className="form__control"
                              onChange={(e) => {
                                const newHistory = [
                                  ...inputValue.employmentHistory,
                                ];
                                newHistory[index] = {
                                  ...newHistory[index],
                                  startDate: e.target.value,
                                };
                                setInputValue({
                                  ...inputValue,
                                  employmentHistory: newHistory,
                                });
                              }}
                              value={employment.startDate}
                            />
                          </div>
                        </div>
                        <div className="basis-1/3">
                          <div className="block">
                            <label className="label">End Date</label>
                            <input
                              type="text"
                              className="form__control"
                              onChange={(e) => {
                                const newHistory = [
                                  ...inputValue.employmentHistory,
                                ];
                                newHistory[index] = {
                                  ...newHistory[index],
                                  endDate: e.target.value,
                                };
                                setInputValue({
                                  ...inputValue,
                                  employmentHistory: newHistory,
                                });
                              }}
                              value={employment.endDate}
                            />
                          </div>
                        </div>
                        <div className="basis-1/3">
                          <div className="block">
                            <label className="label">Job Location</label>
                            <input
                              type="text"
                              className="form__control"
                              onChange={(e) => {
                                const newHistory = [
                                  ...inputValue.employmentHistory,
                                ];
                                newHistory[index] = {
                                  ...newHistory[index],
                                  jobLocations: e.target.value,
                                };
                                setInputValue({
                                  ...inputValue,
                                  employmentHistory: newHistory,
                                });
                              }}
                              value={employment.jobLocations}
                            />
                          </div>
                        </div>
                      </div>
                      <div>
                        <label className="label">Job Description</label>
                        <textarea
                          className="form__control pt-4 resize-none h-28"
                          onChange={(e) => {
                            const newHistory = [
                              ...inputValue.employmentHistory,
                            ];
                            newHistory[index] = {
                              ...newHistory[index],
                              JobDescription: e.target.value,
                            };
                            setInputValue({
                              ...inputValue,
                              employmentHistory: newHistory,
                            });
                          }}
                          value={employment.JobDescription}
                        ></textarea>
                      </div>
                    </div>
                  ))}
                </div>
                <div>
                  <button
                    onClick={addEmploymentHistory}
                    className="bg-indigo-400 hover:bg-indigo-500 transition ease duration-300 text-white rounded flex gap-1 items-center py-1 px-2"
                  >
                    {plusIcon} Add Employment History
                  </button>
                </div>
              </div>
            </div>

            <div className="mb-4 mt-8">
              <div className="block">
                <h3 className="text-lg mb-4">Education</h3>
                <label className="label mb-0">
                  A varied education on your resume sums up the value that your
                  learnings and background will bring to job.
                </label>

                <div className="space-y-4 divide-y">
                  {inputValue.educations.map((education, index) => (
                    <div className="pt-4" key={index}>
                      <div className="flex gap-4 mb-4">
                        <div className="basis-1/2">
                          <div className="block">
                            <label className="label">Institute Name</label>
                            <input
                              type="text"
                              className="form__control"
                              onChange={(e) => {
                                const newEducation = [...inputValue.educations];
                                newEducation[index] = {
                                  ...newEducation[index],
                                  instituteName: e.target.value,
                                };
                                setInputValue({
                                  ...inputValue,
                                  educations: newEducation,
                                });
                              }}
                              value={education.instituteName}
                            />
                          </div>
                        </div>
                        <div className="basis-1/2">
                          <div className="block">
                            <label className="label">Degree</label>
                            <input
                              type="text"
                              className="form__control"
                              onChange={(e) => {
                                const newEducation = [...inputValue.educations];
                                newEducation[index] = {
                                  ...newEducation[index],
                                  degree: e.target.value,
                                };
                                setInputValue({
                                  ...inputValue,
                                  educations: newEducation,
                                });
                              }}
                              value={education.degree}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="flex gap-4 mb-4">
                        <div className="basis-1/3">
                          <div className="block">
                            <label className="label">Passing Year</label>
                            <input
                              type="text"
                              className="form__control"
                              onChange={(e) => {
                                const newEducation = [...inputValue.educations];
                                newEducation[index] = {
                                  ...newEducation[index],
                                  passingYear: e.target.value,
                                };
                                setInputValue({
                                  ...inputValue,
                                  educations: newEducation,
                                });
                              }}
                              value={education.passingYear}
                            />
                          </div>
                        </div>
                        <div className="basis-1/3">
                          <div className="block">
                            <label className="label">Location</label>
                            <input
                              type="text"
                              className="form__control"
                              onChange={(e) => {
                                const newEducation = [...inputValue.educations];
                                newEducation[index] = {
                                  ...newEducation[index],
                                  degreeLocation: e.target.value,
                                };
                                setInputValue({
                                  ...inputValue,
                                  educations: newEducation,
                                });
                              }}
                              value={education.degreeLocation}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div>
                  <button
                    onClick={addEducation}
                    className="
                                    bg-indigo-400
                                    hover:bg-indigo-500
                                    transition ease duration-300
                                    text-white
                                    rounded
                                    flex gap-1 items-center
                                    py-1 px-2"
                  >
                    {plusIcon} Add Education
                  </button>
                </div>
              </div>
            </div>

            <div className="mb-4 mt-8">
              <div className="block">
                <h3 className="text-lg mb-4">Interest</h3>
                <label className="label">What do you like?</label>
                <textarea
                  name="interest"
                  className="form__control resize-none h-28 pt-4"
                  onChange={handleInput}
                  value={inputValue.interest}
                />
              </div>
            </div>
            <div className="mb-4 mt-8">
              <h3 className="text-lg mb-4">Websites & Social Links</h3>
              <label className="label">
                You can add links to websites you want hiring managers to see!
                Perhaps It will be a link to your portfolio, LinkedIn profile,
                or personal website
              </label>
              <div className="mb-4">
                {inputValue.links.map((link, index) => (
                  <div key={index} className="flex gap-4 mb-4">
                    <div className="basis-1/2">
                      <input
                        type="text"
                        className="form__control"
                        name="title"
                        placeholder="Title"
                        onChange={(e) => {
                          const newLinks = [...inputValue.links];
                          newLinks[index] = {
                            ...newLinks[index],
                            title: e.target.value,
                          };
                          setInputValue({ ...inputValue, links: newLinks });
                        }}
                        value={link.title}
                      />
                    </div>
                    <div className="basis-1/2">
                      <input
                        type="text"
                        className="form__control"
                        name="value"
                        placeholder="https://www.example.com"
                        onChange={(e) => {
                          const newLinks = [...inputValue.links];
                          newLinks[index] = {
                            ...newLinks[index],
                            value: e.target.value,
                          };
                          setInputValue({ ...inputValue, links: newLinks });
                        }}
                        value={link.value}
                      />
                    </div>
                  </div>
                ))}

                <div>
                  <button
                    onClick={addNewLinks}
                    className="
                                    bg-indigo-400
                                    hover:bg-indigo-500
                                    transition ease duration-300
                                    text-white
                                    rounded
                                    flex gap-1 items-center
                                    py-1 px-2"
                  >
                    {plusIcon} Add More Link
                  </button>
                </div>
              </div>
            </div>
            <div className="mb-4">
              <label className="label">Skills</label>
              <div className="flex gap-4 mb-4">
                <div className="basis-full">
                  <input
                    type="text"
                    className="form__control"
                    name="skills"
                    placeholder='Separate by "," '
                    onChange={handleInput}
                    value={handleInput.skills}
                  />
                </div>
              </div>
            </div>
          </form>
        </div>

        <div className="basis-1/2 h-screen bg-gray-400 p-4">
          <div className="aspect-[210/297] h-full mx-auto">
            {records.map((elem, index) => {
              return (
                <div
                  key={index}
                  style={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    position: "relative",
                  }}
                >
                  <PdfPreview
                    firstName={elem.firstName}
                    lastName={elem.lastName}
                    avater={previewUrl}
                    email={elem.email}
                    phone={elem.phone}
                    jobTitle={elem.jobTitle}
                    photo={elem.photo}
                    country={elem.country}
                    city={elem.city}
                    address={elem.address}
                    postalCode={elem.postalCode}
                    drivingLicense={elem.drivingLicense}
                    nationality={elem.nationality}
                    placeOfBirth={elem.placeOfBirth}
                    dateOfBirth={elem.dateOfBirth}
                    professionalSummery={elem.professionalSummery}
                    employmentHistory={elem.employmentHistory}
                    educations={elem.educations}
                    links={elem.links}
                    skills={elem.skills}
                    interest={elem.interest}
                  />

                  <div className=" text-center p-2">
                    <PDFDownloadLink
                      className="text-indigo-800 font-medium rounded-md cursor-pointer"
                      document={
                        <PDFFile
                          firstName={elem.firstName}
                          lastName={elem.lastName}
                          avater={previewUrl}
                          email={elem.email}
                          phone={elem.phone}
                          jobTitle={elem.jobTitle}
                          photo={elem.photo}
                          country={elem.country}
                          city={elem.city}
                          address={elem.address}
                          postalCode={elem.postalCode}
                          drivingLicense={elem.drivingLicense}
                          nationality={elem.nationality}
                          placeOfBirth={elem.placeOfBirth}
                          dateOfBirth={elem.dateOfBirth}
                          professionalSummery={elem.professionalSummery}
                          employmentHistory={elem.employmentHistory}
                          educations={elem.educations}
                          links={elem.links}
                          skills={elem.skills}
                          interest={elem.interest}
                        />
                      }
                      fileName="cv.pdf"
                    >
                      {({ blob, url, loading, error }) =>
                        loading ? "" : "Download now!"
                      }
                    </PDFDownloadLink>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* <div className="basis-1/2 h-screen bg-gray-100"> */}
        {/* {
                records.map((elem, index) => {
                    return(
                        <div key={index}> */}
        {/* <PDFViewer showToolbar={false}>
                                <PDFFile
                                    firstName={elem.firstName}
                                    lastName={elem.lastName}
                                    email={elem.email}
                                    phone={elem.phone}
                                    jobTitle={elem.jobTitle}
                                    photo={elem.photo}
                                    country={elem.country}
                                    city={elem.city}
                                    address={elem.address}
                                    postalCode={elem.postalCode}
                                    drivingLicense={elem.drivingLicense}
                                    nationality={elem.nationality}
                                    placeOfBirth={elem.placeOfBirth}
                                    dateOfBirth={elem.dateOfBirth}
                                    professionalSummery={elem.professionalSummery}
                                    employmentHistory={elem.employmentHistory}
                                    education={elem.education}
                                    site={elem.site}
                                    link={elem.link}
                                    skills={elem.skills}
                                    interest={elem.interest}
                                />
                            </PDFViewer> */}

        {/* <PDFDownloadLink document={
                                <PDFFile
                                    firstName={elem.firstName}
                                    lastName={elem.lastName}
                                    email={elem.email}
                                    phone={elem.phone}
                                    jobTitle={elem.jobTitle}
                                    photo={elem.photo}
                                    country={elem.country}
                                    city={elem.city}
                                    address={elem.address}
                                    postalCode={elem.postalCode}
                                    drivingLicense={elem.drivingLicense}
                                    nationality={elem.nationality}
                                    placeOfBirth={elem.placeOfBirth}
                                    dateOfBirth={elem.dateOfBirth}
                                    professionalSummery={elem.professionalSummery}
                                    employmentHistory={elem.employmentHistory}
                                    educations={elem.educations}
                                    links={elem.links}
                                    skills={elem.skills}
                                    interest={elem.interest}
                                    avater={previewUrl}
                                />
                            } fileName='cv.pdf'>
                                {({ blob, url, loading, error }) =>
                                    <div>
                                        {loading ? 'Loading document...' : 'Download now!'}
                                    </div>
                                }
                            </PDFDownloadLink> */}
        {/* </div>
                    )
                })
            } */}
        {/* </div> */}
      </div>
    </>
  );
}

export default Form;
